module.exports = __webpack_public_path__ + "img/voice-icon14.744bdd5.png";